import { Button, LoadingSpinner } from '@idexx-laboratories/spot-react';
import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Grid from '../../components/Grid/Grid';
import { useStore } from '../../hooks/use-store';
import { checkSinglePermission } from '../../security/security-hook';
import { PERMISSION_ALLOW, RESOURCE_SERVICE_EVENTS_ADD } from '../../types/users-types';
import { isDefined } from '../../utils/object-utils';
import './ServiceEvents.scss';

const ServiceEvents = observer(() => {
  const { serviceEventsStore: store, globalStore } = useStore();
  const { colDefs, sortedItems, loaders, sorting } = store;
  const navigate = useNavigate();

  useEffect(() => {
    void store.init();
  }, [navigate, store]);

  if (loaders.page) return <LoadingSpinner size='large' />;

  const addItemBtnIsEnabled = checkSinglePermission(
    globalStore.root.apiStore.userGlobalPermissions,
    RESOURCE_SERVICE_EVENTS_ADD,
    PERMISSION_ALLOW,
  );

  return (
    <div className='service-events-wrapper'>
      <div className='spot-typography__heading--level-2'>Service Events</div>
      <div className='page-top-actions'>
        <div>
          <Button
            className='add-more-btn'
            aria-label='Add More'
            variant='link'
            size='small'
            iconLeft='plus'
            disabled={loaders.action || !addItemBtnIsEnabled}
            onClick={() => store.addItem()}
          >
            Add Event
          </Button>
          {loaders.action && <LoadingSpinner />}
        </div>
        <Button
          variant='primary'
          size='small'
          onClick={() => void store.refresh()}
          disabled={loaders.action}
        >
          Refresh List
        </Button>
      </div>
      <Grid id='service-events-grid' columns={colDefs} data={sortedItems} sorting={sorting} />
      <div className='horizontal-flex-box page-bottom-actions'>
        <Button className='back' variant='link' size='small' onClick={() => navigate(-1)}>
          Back
        </Button>
        <div className='main-buttons'>
          <Button
            variant='primary'
            size='small'
            disabled={loaders.action || isDefined(store.currentItemIndex)}
            onClick={() => navigate('/')}
          >
            Dashboard
          </Button>
        </div>
      </div>
    </div>
  );
});

export default ServiceEvents;
